import React from "react";

function MentorShip() {
	return (
		<>
			<div id="qotd">
				<h1>Mentor Ship Form</h1>

				<div className="select-input">
					<label for="cars">Name</label>
					<input type="text" />
				</div>
				<br />
				<div className="select-input">
					<label>Designation</label>
					<input type="text" />
				</div>
				<br />
				<div className="select-input">
					<label for="cars">Select Course</label>
					<select>
						<option value="answer">Question</option>
						<option value="mcq">MCQ</option>
					</select>
				</div>
				<br />
				<div className="select-input">
					<label>Image Link</label>
					<input type="text" />
				</div>
				<br />
				<div className="select-input">
					<label for="cars">Rating</label>
					<select>
						<option value="answer">1</option>
						<option value="mcq">2</option>
						<option value="mcq">3</option>
						<option value="mcq">4</option>
						<option value="mcq">5</option>
					</select>
				</div>
				<br />

				<button className="Qotd-btn">SUBMIT</button>
			</div>
		</>
	);
}

export default MentorShip;
